var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"option",class:{ hasError: _vm.hasValidationError }},[(_vm.option.input.type)?_c(_vm.option.input.type,{tag:"component",attrs:{"option":_vm.option}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }